import Client from '../Client';
import * as _ from 'es-toolkit';

class AttendanceStats {
    constructor() {
        this.client = new Client();
    }

    /**
     * @param {Object} params - Query parameters (from/to mapped to start_date/end_date for Kore)
     */
    getStats(params) {
        const q = {
            start_date: params.from || params.start_date,
            end_date: params.to || params.end_date,
            bucket_minutes: params.bucket_minutes,
            metric: params.metric,
            group_by: params.group_by,
            compare_to: params.compare_to,
            align: params.align,
            compare_start_date: params.compare_start_date,
            compare_end_date: params.compare_end_date,
            movie: params.movie,
            version: params.version,
        };
        if (params.places?.length)
            q.places = params.places;
        if (params.hall_filters?.length)
            q.hall_filters = params.hall_filters;
        const query = _.pickBy(q, v => v !== undefined && v !== null && v !== '');

        return this.client.GET('/stats/attendance_stats', query)
            .then(async response => {
                if (!response.ok) {
                    throw new Error(`Failed to load attendance stats (${response.status})`);
                }
                try {
                    const json = await response.json();
                    return { stats: json.stats };
                } catch (error) {
                    throw new Error('Invalid attendance stats response payload');
                }
            })
            .catch(error => {
                if (error instanceof TypeError && /failed to fetch/i.test(error.message || ''))
                    throw new Error('Network error while loading attendance stats');
                throw error;
            });
    }
}

const AttendanceStatsApi = new AttendanceStats();

export default AttendanceStatsApi;
